// extracted by mini-css-extract-plugin
export default {"container":"ka","hidden":"la","column":"ma","headline":"na"};